// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './get-budget-support-types-query.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetBudgetSupportTypesListQueryVariables = GraphQLSchema.Exact<{
  consumerUserId?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['ID']['input']>;
  postedJobId?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['ID']['input']>;
}>;


export type GetBudgetSupportTypesListQuery = { __typename?: 'Query', budgetSupportTypes?: { __typename?: 'CarerBudgetSupport', defaultBudgetSupportTypes?: Array<{ __typename?: 'BudgetSupportType', id: string, name: string, displayName?: string | null, isAdminOnlyType?: boolean | null }> | null, availableBudgetSupportTypes?: Array<{ __typename?: 'BudgetSupportType', id: string, name: string, displayName?: string | null, isAdminOnlyType?: boolean | null }> | null } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class GetBudgetSupportTypesListQueryService extends Apollo.Query<GetBudgetSupportTypesListQuery, GetBudgetSupportTypesListQueryVariables> {
    document = Operations.GetBudgetSupportTypesListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }